// src/components/LandingPage/FindingCard.tsx
import { LucideIcon, ArrowRight } from 'lucide-react';

interface FindingCardProps {
  title: string;
  description: string;
  icon: LucideIcon;
  onMoreInfo?: () => void; // Nuevo prop para manejar el clic en "Más info"
}

export function FindingCard({ title, description, icon: Icon, onMoreInfo }: FindingCardProps) {
  return (
    <div
      className="
        group relative overflow-hidden rounded-lg bg-[#1E293B] p-8 shadow-lg transition-all 
        hover:shadow-2xl hover:shadow-red-500/30 border border-gray-700 
        hover:border-red-500 hover:bg-[#2A1B1B] hover:scale-105 duration-500 ease-in-out 
        h-full flex flex-col
      "
    >
      {/* Icono en la parte superior */}
      <div className="mb-4 inline-block rounded-lg bg-lime-500/20 p-4">
        <Icon className="h-8 w-8 text-white" />
      </div>

      {/* Contenido */}
      <div className="flex-grow">
        <h3 className="mb-2 text-xl font-semibold tracking-tight text-white">{title}</h3>
        <p className="text-gray-300">{description}</p>
      </div>

      {/* Botón "Más info" */}
      <button
        onClick={onMoreInfo}
        className="mt-4 inline-flex items-center text-sm text-white hover:text-gray-300 opacity-0 group-hover:opacity-100 transition-opacity"
      >
        <span className="mr-1">Más info</span>
        <ArrowRight className="h-4 w-4 text-white" />
      </button>
    </div>
  );
}
